module.exports = __webpack_public_path__ + "static/media/Icn-xml.83495679.svg";